import React, {FC} from "react"

import withAuth, {WithAuth} from "@irati/auth/helpers/auth/withAuth"
import {CompanyNewsTile, CompanyNewsTileType} from "@irati/types"
import Button from "@irati/ui/src/Button"
import FormattedMessage from "@irati/utils/lang"
import {updateCompanyNewsTile} from "@irati/culture-hub/services/homepage"
import tracking from "@irati-tracking/homepage"
import {Body, H4} from "@irati/ui/src/Typography"

import {Modal} from "../Modal"
import {ModalContent, StyledFooter} from "../Modal/styled"

interface Props extends WithAuth {
  companyNewsTile: CompanyNewsTile,
  onClose: () => void
}

const deleteTile = (tileToUpdate: CompanyNewsTile, onClose: () => void, businessId: string) => {
  const tile = {
    config: {
      columnWidth: tileToUpdate.config.columnWidth,
      type: CompanyNewsTileType.Empty,

      // reset the tiles values back to empty
      backgroundColor: undefined,
      imageUrl: undefined,
      message: undefined,
      templateIcon: undefined,
      templateText: undefined,
      url: undefined,
      videoUrl: undefined
    },
    xpos: tileToUpdate.xpos,
    ypos: tileToUpdate.ypos
  }

  const variables = {
    tenantId: businessId,
    tile
  }

  // @todo loading
  // ts error due to required types (not required by graph)
  // @ts-ignore
  updateCompanyNewsTile(variables).then(() => {
    tracking.homePageDeleteTile()
    onClose()
  })
}

const DeleteTileModal: FC<Props> = ({companyNewsTile, onClose, auth}) => {
  return (
    <Modal
      header={
        <H4>
          <FormattedMessage id="platform.homepage.companyNews.deleteTile.title" />
        </H4>
      }
      onClose={onClose}>
      <>
        <ModalContent>
          <Body>
            <FormattedMessage id="platform.homepage.companyNews.deleteTile.message" />
          </Body>
        </ModalContent>
        <StyledFooter>
          <Button tertiary onClick={onClose}>
            <FormattedMessage id="platform.homepage.companyNews.deleteTile.cancel" />
          </Button>
          <Button primary marginLeft={2} onClick={() => deleteTile(companyNewsTile, onClose, auth.business.uuid)}>
            <FormattedMessage id="platform.homepage.companyNews.deleteTile.delete" />
          </Button>
        </StyledFooter>
      </>
    </Modal>
  )
}

export default withAuth(DeleteTileModal)
